import { basic, ui } from 'api';
import {
  UI_SET_LOADER,
  UI_SET_LOADER_TEXT,
  SET_UI_PROPERTY,
  SET_PARTNER_DATA,
  GET_MARKDOWN_FILE,
  GET_PARTNER_DATA,
  UI_GET_VEHICLE_MARKS,
  UI_GET_VEHICLE_MODELS,
  UI_GET_VEHICLE_STYLE_BODY,
  UI_SET_VEHICLE_MARKS,
  UI_SET_VEHICLE_MODELS,
  UI_SET_VEHICLE_STYLE_BODY
} from 'store/actions/ui';

export default {
  [UI_SET_LOADER]: ({ commit }, loading) => {
    commit(UI_SET_LOADER, loading);
  },

  [GET_PARTNER_DATA]: ({ commit }, { id }) =>
    new Promise((resolve, reject) => {
      basic
        .getPartnerData(id)
        .then(resp => {
          commit(SET_PARTNER_DATA, resp.data);
          resolve();
        })
        .catch(err => {
          commit('ERROR_OCCURRED', err, { root: true });
          reject();
        });
    }),

  [UI_SET_LOADER_TEXT]: ({ commit }, text) => {
    commit(UI_SET_LOADER_TEXT, text);
  },

  [SET_UI_PROPERTY]: ({ commit }, { field, value }) =>
    commit(SET_UI_PROPERTY, {
      field,
      value
    }),

  [GET_MARKDOWN_FILE]: ({ commit, getters }, { url, field }) =>
    new Promise((resolve, reject) => {
      if (!getters.dataUI(field)) {
        basic.getMarkdownFile(url).then(
          resp => {
            const data = resp.data;
            commit(SET_UI_PROPERTY, {
              field,
              value: data
            });
            resolve();
          },
          err => {
            commit('ERROR_OCCURRED', err, {
              root: true
            });
            reject();
          }
        );
      } else {
        resolve();
      }
    }),

  [UI_GET_VEHICLE_MARKS]: ({ commit }) =>
    new Promise((resolve, reject) => {
      ui.getBrands().then(
        resp => {
          const marks = resp.data;
          commit(UI_SET_VEHICLE_MARKS, marks);
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, {
            root: true
          });
          reject();
        }
      );
    }),

  [UI_GET_VEHICLE_MODELS]: ({ commit }, mark) =>
    new Promise((resolve, reject) => {
      ui.getModelByBrand(mark).then(
        resp => {
          const models = resp.data;
          commit(UI_SET_VEHICLE_MODELS, models);
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, {
            root: true
          });
          reject();
        }
      );
    }),

  [UI_GET_VEHICLE_STYLE_BODY]: ({ commit }, mark) =>
    new Promise((resolve, reject) => {
      ui.getVehicleTypeByBrand(mark).then(
        resp => {
          const items = resp.data;
          commit(UI_SET_VEHICLE_STYLE_BODY, items);
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, {
            root: true
          });
          reject();
        }
      );
    })
};
